import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { assert } from '@sama/js-core';
import { map, Observable } from 'rxjs';
import { AbstractNestableOutputComponent } from '../abstract-nestable-output.component';

@Component({
  selector: 'h3-dropdown-output',
  templateUrl: './dropdown-output.component.html',
  styleUrls: ['./dropdown-output.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DropdownOutputComponent
  extends AbstractNestableOutputComponent
  implements OnInit
{
  trainingAnswerLabel$!: Observable<string | undefined>;

  override ngOnInit() {
    super.ngOnInit();
    this.trainingAnswerLabel$ = this.trainingAnswer$.pipe(
      map((answer) => {
        if (!this.answerOptions || !answer) {
          return undefined;
        }
        const selection = this.answerOptions.find(
          (option) => option.name === answer,
        );
        return selection?.label || undefined;
      }),
    );
  }

  override buildReadOnlyText$() {
    return this.outputInfoStore('answer').$.pipe(
      map((answer) => {
        assert(
          this.answerOptions,
          'Dropdowns are outputs with answer options.',
        );
        const selection = this.answerOptions.find(
          (option) => option.name === answer,
        );
        return selection?.label ?? '';
      }),
    );
  }
}
